import { cols } from "@/config/system";
import { momentFormat } from "@/utils/formatter";

export const tableColumn = [
  {
    type: "index",
    label: "序号",
    fixed: true,
    disabled: true,
  },
  {
    label: "导出时间",
    prop: "gmtCreate",
    formatter: (row: any, column: any, cellValue: string) =>
      momentFormat(cellValue, "YYYY-MM-DD HH:mm:ss")
  },
  {
    label: "导出内容",
    prop: "methodDescription",
  },
  {
    label: "导出状态",
    prop: "fileStatus",
    formatter: (row: any, column: any, cellValue: number) => {
      return [ '导出中','导出成功', '导出失败', '导出失败'][cellValue]
    }
  },
  {
    label: "操作",
    prop: "actions",
    slotName: 'actions'
  }
];
